export const wrapperStylesFactory = (intl) => {
    const { $t } = intl;
    return [
        {
            value: 'card',
            text: $t({ id: 'Generics.Card', defaultMessage: 'Card' }),
        },
        {
            value: 'flat',
            text: $t({ id: 'Generics.Flat', defaultMessage: 'Flat' }),
        },
        {
            value: 'rounded',
            text: $t({ id: 'Generics.Rounded', defaultMessage: 'Rounded' }),
        },
    ];
};
export const bgImagePositionsFactory = (intl) => {
    const { $t } = intl;
    return [
        {
            text: $t({ id: 'Generics.Cover', defaultMessage: 'Cover' }),
            value: 'cover',
        },
        {
            text: $t({ id: 'Generics.Contain', defaultMessage: 'Contain' }),
            value: 'contain',
        },
        {
            text: $t({ id: 'Generics.Repeat', defaultMessage: 'Repeat' }),
            value: 'repeat',
        },
        {
            text: $t({ id: 'Generics.NoRepeat', defaultMessage: 'No repeat' }),
            value: 'no-repeat',
        },
    ];
};
//# sourceMappingURL=utils.js.map